import React, { Component } from 'react';
import Ribbon from '@/components/organisms/Ribbon';
// import ContentXearch from '@/components/organisms/ContentXearch';
// import Content from '@/components/organisms/Content';
// import Grid from '@/components/grid/agGrid';
import CustomAlert from "@/components/molecules/CustomAlert";
import AlertDialog from '@/components/material-UI/AlertDialog';
import * as Common from '@/utils/Common'; 
import CommonUtil from '@/utils/CommonUtil'; 
// import { stringToArray } from 'ag-grid-community';
// import ContentTwo from '../../components/organisms/ContentTwo';
// import RNTW0 from '@/pages/B05/RNTW0';


import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import styled from 'styled-components';
// import { EditorState } from 'draft-js';
import { EditorState, convertToRaw, ContentState } from "draft-js";
// import { EditorState, convertToRaw, getCurrentContent } from "draft-js";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { TimerSharp, Visibility } from '@material-ui/icons';
import { getElementError } from '@testing-library/react';
 
const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER; 
// const CODES = require('@/config/commonCode.json');
// const Utils = new CommonUtil();

const MyBlockQW = styled.div`
.wrapper-class{
    width: 97%;
    margin: 0 auto;
    margin-bottom: 4rem;
}
.editor-class {
    height: 500px !important;
    border: 1px solid #b8b8b8 !important;
    padding: 5px !important;
    border-radius: 2px !important;
}
.toolbar-class {        
    border: 1px solid #f1f1f1 !important;
}
`;


class FaqWrite extends Component {

    constructor(props)  {
        super(props);
        //this.grdCarTypeMain = React.createRef();
        this.state = {
            // Common
            token:Common.getToken(),
            userId :Common.getToken("id"),
            userName : Common.getToken("name"),
            tVnt1 : Common.getToken("vand"),
            tComp : Common.getToken("comp"),
            uid : props.data.userId +  props.data.userName,
            idat:Common.getToday(),
            titl:props.data.chk === 1 ? props.data.titl:"",
            gubn:props.data.gubn == undefined ? "1" : props.data.gubn,
            vdnm:props.data.vdnm,
            gubn:props.data.gubn,
            loginVdnm:"",
            numb:props.data.numb,
            chk:props.data.chk,
            text:props.data.text,
            cont:Common.getToken("vand") === "M000"?`
            
            ※ 고객팀 1688-0720 또는 카카오상담 itnjinc(고객지원 > 고객지원 > 카카오상담) 이용하시면 보다 빠른 답변이 가능합니다
※ 이미지 및 파일첨부는 '카카오채팅'으로 보내주시기 바랍니다 :)`:``,
            close:"",
            //Alert 창 ( Alert 창 OPEN,  Alert 창 구분, Alert 창 메세지)
            openAlert : false, severity : "success", msg : "",
    
            //Dialog 창 (Dialog 창 OPEN, Dialog Transaction(I,U,D),  Dialog 메세지)
            openDlg : false, dlgTrans : "", dlgMsg : "", 
    
            //Api (조회, 등록, 수정, 삭제)
            searchApi : false, insertApi : false, updateApi : false, deleteApi : false,
            
            gubnList : [],

            loadingFlag : false,
            editorState: EditorState.createEmpty() // 에디터 용
        }
    }

   
    /**
     * WillMount
     */
    async componentWillMount() {
        this.setState({loadingFlag : true}); 

        // 구분 공통코드
        let commonCode2 = await Promise.all([this.onSearchComp(`{"pgmid":"CODE", "vand":"****", "gocd" : "FAQ"}`, "gubnList" ) ]);
        // 구분 공통코드
        this.setState({gubnList: commonCode2[0].gubnList, loadingFlag : true}); 
    }

    onSearchVdnm = async (para) => {
        let commonData = this.state;
        let param = encodeURI(para);

        const query = SERVER_URL + "/comcd/search1?query=" + param; 

        await fetch(query, { headers: { Authorization: this.state.token } })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) { 
                        //elements[element.text] = element.comCode;
                        commonData["loginVdnm"] = data.data[0].text; //업체명
                        this.setState({...commonData});
                }
            })
        return commonData;
    }

    /**
     * DidMount
     */
    componentDidMount() {
        this.onSearchVdnm(`{"pgmid":"WRCVAND", "kVnt1":"${this.state.tVnt1}"}`);
        this.onSearchComp(`{"pgmid":"CODE", "vand":"****", "gocd" : "FAQ"}`, "gubnList" );
        let para = `{"numb":"${this.state.numb}"}`;//조회수 업데이트-> num , 내용조회-> numb
        let param = encodeURIComponent(para);
        const query = SERVER_URL + "/faq/search2?query=" + param;

        const fetchSearchData = async (query) => {
            let inputData = this.state; 
            await fetch(query,  { headers: { Authorization: this.state.token } })
                .then((resp) => resp.json())
                .then((data) => {

                    if (data.success) {
                        inputData["titl"] = data.data[0].titl; //제목
                        inputData["cont"] = data.data[0].cont; //내용
                        inputData["gubn"] = data.data[0].gubn; //구분

                        //에디터에 값 추가 
                        const blocksFromHtml = htmlToDraft(data.data[0].cont);
                        // const blocksFromHtml = htmlToDraft(`${data.data[0].cont}`);

                        if (blocksFromHtml) { 
                            const {contentBlocks, entityMap} = blocksFromHtml; 
                            // https://draftjs.org/docs/api-reference-content-state/#createfromblockarray 
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap); 
                            // ContentState를 EditorState기반으로 새 개체를 반환. 
                            // https://draftjs.org/docs/api-reference-editor-state/#createwithcontent 
                            const editorState = EditorState.createWithContent(contentState); 

                            // const contentBlock = htmlToDraft(blocksFromHtml);
                            // const editorState = ContentState.createFromBlockArray(contentBlock.contentBlocks);

                            //setEditorState(editorState); // <== 이부분 
                            inputData["editorState"] = editorState;
                        }


                        this.setState({ ...inputData });
                    }
                    if (data.error) {
                        //inputData["cont"] = this.state.cont

                        //에디터에 값 추가 
                        const blocksFromHtml = htmlToDraft(this.state.cont);

                        if (blocksFromHtml) { 
                            const {contentBlocks, entityMap} = blocksFromHtml; 
                            // https://draftjs.org/docs/api-reference-content-state/#createfromblockarray 
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap); 
                            // ContentState를 EditorState기반으로 새 개체를 반환. 
                            // https://draftjs.org/docs/api-reference-editor-state/#createwithcontent 
                            const editorState = EditorState.createWithContent(contentState); 

                            // const contentBlock = htmlToDraft(blocksFromHtml);
                            // const editorState = ContentState.createFromBlockArray(contentBlock.contentBlocks);

                            //setEditorState(editorState); // <== 이부분 
                            inputData["editorState"] = editorState;
                        }


                        this.setState({ ...inputData });

                        this.setState({ openAlert : true, 
                                        severity : "error",
                                        msg : "내용 입력 해주세요 :)"});
                    }
                })
                .catch((error) => {
                    // 에러 응답 처리
                    if (error) {
                        this.setState({ openAlert : true, 
                                        severity : "error",
                                        msg : "서버 상태를 확인해 주세요. 관리자에게 문의해주세요."});
                    }
                });
        };
        fetchSearchData(query);
    }


    /**
     * 공통코드 조회
    */
     onSearchCommon = (para, name) => {

        
    }
    
    // 에디터 값 변경 시 
    onEditorStateChange = (editorState) => {
        let value = draftToHtml(convertToRaw(editorState.getCurrentContent()));


        let newSearchs = this.state;
        newSearchs["editorState"] = editorState;
        newSearchs["cont"] = value;
        this.setState({ ...newSearchs });
    }

        /**
     * 회사구분 코드 조회
    */
         onSearchComp = async (para,name) => {
            let commonData = this.state;
            let param = encodeURIComponent(para);
    
            const query = SERVER_URL + "/comcd/search1?query=" + param; 
            await fetch(query, { headers: { Authorization: this.state.token } })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success)    
                    {
                        commonData[name] = data.data
                        this.setState({...commonData});
                    }
                })
            return commonData;
        }

    render() {

        if (this.state.loadingFlag === false) {
            return null
        }
        else {
        
            //State
            const {token, userId, userName, tVnt1, tComp, kDelGubn, mode,uid,numb,gubn,close,
                   openAlert, severity, msg,idat,titl,vdnm,cont,loginVdnm,gngb,gubnList,
                   openDlg, dlgTrans, dlgMsg, compList, searchApi, insertApi, updateApi, deleteApi,setTypeOpen } = this.state;


            /**
             * Control 변경 Event
             * @param {*} e 
             */
            const onChange = async (e) => {
                const { name, value } = e.target;

                let newSearchs = this.state;
                newSearchs[name] = value
                this.setState({ ...newSearchs });
            }

        
            /**
             * 검색조건
            */
            const optionsX = {
                0: [
                    {"formatter": "blank", "align": "left" },
                    {"formatter": "blank", "align": "left" },
                    {"formatter": "blank", "align": "left" },
                    {"formatter": "blank", "align": "left" },
                    {"formatter": "blank", "align": "left" },
                    {"formatter": "blank", "align": "left" },
                    {"formatter": "blank", "align": "left" },
                ],
            }


        
            /**
             * 조회
             * @param {*} e 
             */
            const onSearch = async (e) => { 
              
            }



            /**
             * 신규 Row추가
             * @param {*} e 
             */
            const onAddRow = async (e) => {
            }



            /**
             * 입력
             * @param {*} e 
             */
            const onInsert = async (e) => {                                                       
                if(this.state.gubn == "" || this.state.gubn == null || this.state.gubn == "0"){
                    this.setState({ openAlert : true, 
                        severity : "error",
                        msg : "구분을 선택해주세요."});
                    return
                }
                else if(this.state.titl == "" || this.state.titl == null ){
                    this.setState({ openAlert : true, 
                        severity : "error",
                        msg : "제목을 입력해주세요."});
                    return
                }            

                const fetchInsertData = async () => {

                    const query = SERVER_URL + "/faq/insert"; 
                    let param = JSON.stringify({
                        
                        vand : this.state.tVnt1,
                        iusa : this.state.userId,
                        pseq : this.state.chk === 0 ? this.state.chk : this.state.numb,
                        idat : this.state.idat,
                        titl : this.state.titl,
                        cont : this.state.cont,
                        // gubn : this.state.gubn,
                        gubn: this.state.gubn,
                        numb:this.state.numb,
                    });

                    await fetch(query, { method: "POST", headers: { Authorization: token, "Content-Type": "application/json" }, body: param })                        
                        .then((resp) => resp.json())
                        .then((data) => {

                            if (data.success) {
                                this.setState({ openAlert : true, 
                                                severity : "success",
                                                msg : data.data.message});
                            }

                            else if (data.errors) {
                                this.setState({ openAlert : true, 
                                                severity : "error",
                                                msg : data.errors.message});
                            }
                            else if (data.error) {
                                this.setState({ openAlert : true, 
                                                severity : "error",
                                                msg : data.message});
                            }
                        })
                        .catch((error) => {
                            // 에러 응답 처리
                            if (error) {
                                this.setState({ openAlert : true, 
                                                severity : "error",
                                                msg : "서버 상태를 확인해 주세요. 관리자에게 문의해주세요."});
                            }
                        });
                };
                fetchInsertData();

                setTimeout(() => this.props.onClose(), 1000); //refresh onClose 호출
            }



            /**
             * 수정 
             * @param {*} e 
             * @returns 
             */
            const onUpdate = async (e) => {

                let param = JSON.stringify({
                   
                });
                //alert(param);
                const fetchUpdateData = async () => {

                    const query = SERVER_URL + "/faq/update"; 
                    let param = JSON.stringify({
                        titl : titl,
                        numb : numb,
                        cont : cont,
                        // vand : this.state.tVnt1,
                        // iusa : this.state.userId,
                        // pseq : this.state.chk === 0 ? this.state.chk : this.state.numb,
                        // idat : this.state.idat,
                        // titl : this.state.titl,
                        // cont : this.state.cont,
                        // gngb: this.state.gngb,
                        // numb:this.state.numb,

                    });

                    await fetch(query, { method: "POST", headers: { Authorization: token, "Content-Type": "application/json" }, body: param })                        
                        .then((resp) => resp.json())
                        .then((data) => {
                            if (data.success) {
                                this.setState({ openAlert : true, 
                                                severity : "info",
                                                msg : data.count + "건 작업을 수행하였습니다. "});
                            }
                            else if (data.errors) {
                                this.setState({ openAlert : true, 
                                                severity : "error",
                                                msg : data.errors.message});

                            }
                            else if (data.error) {
                                this.setState({ openAlert : true, 
                                                severity : "error",
                                                msg : data.message});
                            }
                        })
                        .catch((error) => {
                            // 에러 응답 처리
                            if (error) {
                                this.setState({ openAlert : true, 
                                                severity : "error",
                                                msg : "서버 상태를 확인해 주세요. 관리자에게 문의해주세요."});
                            }
                        });
                };
                fetchUpdateData();
            }



            /**
             * 삭제
             * @param {*} e 
             */
            const onDelete = async (e) => {

                const fetchDeleteData = async () => {

                    const query = SERVER_URL + "/faq/delete"; 
                    let param = JSON.stringify({
                        numb : numb,
                    });

                    await fetch(query, { method: "POST", headers: { Authorization: token, "Content-Type": "application/json" }, body: param })                        
                        .then((resp) => resp.json())
                        .then((data) => {
                            if (data.success) {
                                this.setState({ openAlert : true, 
                                                severity : "info",
                                                msg : data.count + "건 작업을 수행하였습니다. "});
                            }
                            else if (data.errors) {
                                this.setState({ openAlert : true, 
                                                severity : "error",
                                                msg : data.errors.message});

                            }
                            else if (data.error) {
                                this.setState({ openAlert : true, 
                                                severity : "error",
                                                msg : data.message});
                            }
                        })
                        .catch((error) => {
                            // 에러 응답 처리
                            if (error) {
                                this.setState({ openAlert : true, 
                                                severity : "error",
                                                msg : "서버 상태를 확인해 주세요. 관리자에게 문의해주세요."});
                            }
                        });
                };
        
                fetchDeleteData();

            }



            //deleteBlank
            function deleteBlank(argval){

            }




            //AlertDialogResult
            const AlertDialogResult = async (e) => {

                //AlertDialog 초기화
                this.setState({ openDlg : false,  dlgTrans : "", dlgMsg : ""});
        
                //DialogResult
                if (e.result == "N") return;
        
                //Transaction 구분
                switch (e.Trans) 
                {
                    //등록
                    case "I" :
                        break;
                    //수정
                    case "U" :
                        break;
                    //삭제
                    case "D" :
                        break;
                }
            }

        

            //Grid DropDownList Value
            const extractValues = (mappings) => {
                return  Object.keys(mappings);
            }

            //Grid DropDownList Display
            const lookupValue = (mappings, key) => {
                return mappings[key];
            }        
            
           
            /**
             *Grid Column 정의 
            */
            const columnDefs = [
            ];

            return (
                <>
                    {/* Dialog FRAME */}
                    <AlertDialog open={openDlg}  trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />

                    {/* Alert FRAME */}
                    <CustomAlert open={openAlert} severity={severity} duration={3000} message={msg} onClose={()=> {this.setState({openAlert:false, severity:"", msg:""})}} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} />
                    <button onClick={() => {this.props.onClose()}} style = {{border:"none", float:"right"}}> <img src="/images/button/close_button.png" alt="logout" /></button> 
                    {/* Ribbon Frame : 프로그램 Path 및 버튼 */}
                    <Ribbon
                        newTabUnused={true}                         // newTabUnused : newTab 표출 버튼 true : 사용안함 // 선언안할경우 default = newTab 사용
                        onInfoManual={false}                        // onInfoManual : 매뉴얼 표출 버튼 무조건 사용 // false : 사용안함 (popup 의경우 false 셋팅)
                        onSearch={onSearch} onSearchName={null}     //조회
                        onInsert={onInsert} onInsertName={"입력"}  onInsertVisible = {tVnt1 === "M000"}
                        onUpdate={onUpdate} onUpdateVisible = {tVnt1 === "M000"}     //등록
                        onDelete={onDelete} onDeleteVisible = {tVnt1 === "M000"}     //등록
                        
                    >
    
                    <b style={{ color: "#cd5c5c", fontFamily: "PretendardLight, NanumGothic, sans-serif" }}>FAQ</b>
                    </Ribbon>

                     <div style={{ height: "82px", paddingTop: "10px", background:" rgb(241, 243, 247)",marginTop: "8px",borderTop: "1px solid #cecdd9",borderBottom: "1px solid #cecdd9" }}> {/* Content 항목에서의 100%에서 Header:60px,  Ribbon:50px,  검색조건:100px */}
                        
                        <div className={"grid_type06"} >{/* 우측 FRAME */}
                        <div className="grid_wrap06" style={{height: "15%"}} > {/* 우측 wrap FRAME */}
                            <div className="grid_area" style={{ height: "13%", border: "0px solid #babfc7", width:"100%" }}> {/* Grid area */}
    
                                <table  style={{ width: "100%" }}>
                                    <colgroup>
                                        <col width="10%" />
                                        <col width="22.5%" />
                                        <col width="22.5%" />
                                        <col width="22.5%" />
                                        <col width="22.5%" />
                                    </colgroup>
                                    <tbody>
                                    
                                    <tr style={{ height:"28px",border:"0px",background: "#F1F3F7"}}>   
                                        <td style={{verticalAlign: "middle",border:"0px",background: "#F1F3F7",textAlign:"Right",whiteSpace:"nowrap"}}>구분 :</td>
                                        <td>
                                        <select name="gubn" value={gubn == "" || gubn == undefined ? "1" : gubn } onChange={onChange} style={{width:"120px",height:"26px",marginLeft:"15px",border:"1px solid #b8b8b8",padding:"0px 0px 0px 0px"}}>
                                        <option value={"0"}>선택</option>
                                            {gubnList.map(element => ( 
                                                <option key={element.comCode} value={element.comCode}>
                                                        {element.text} 
                                                </option>
                                            ))
                                            }
                                        </select>
                                        </td>
                                    </tr>                                                                 
                                    <tr style={{ height:"28px",border:"0px",background: "#F1F3F7"}}>   
                                        <td className="k_upload" style={{verticalAlign: "middle",border:"0px",background: "#F1F3F7",textAlign:"Right",whiteSpace:"nowrap"}}>제목 : </td>
                                        <td colSpan = "4" style={{border:"0px",background: "#F1F3F7"}}>
                                        <input name="titl" onChange={onChange} style={{width:"519px",height:"26px",marginLeft:"15px",border:"1px solid #b8b8b8",padding: "5px"}} value = {this.state.chk === 0 ? titl :titl}/>
                                        </td>
                                    </tr>                                
                                    </tbody>
                                </table>   {/*<!-- DO 테이블 END --> */}
                            </div>
                        </div>
                        <table  style={{ width: "100%",marginTop: "7px" }}>
                                    <colgroup>
                                        <col width="10%" />
                                        <col width="90%" />
                                    </colgroup>
                                    <tbody>
                                    <tr style={{ height:"28px",border:"0px"}}>
                                        <td style={{border:"0px",textAlign:"Right",verticalAlign: "top",paddingTop:"15px",whiteSpace:"nowrap"}}>내용 : </td>            
                                        <td colSpan = "2" style={{border:"0px"}}>
                                            <MyBlockQW>
                                                <Editor                                                    
                                                    wrapperClassName="wrapper-class"    // 에디터와 툴바 모두에 적용되는 클래스
                                                    editorState={this.state.editorState}// 초기값 설정
                                                    editorClassName="editor-class"      // 에디터 주변에 적용된 클래스
                                                    toolbarClassName="toolbar-class" // 툴바 주위에 적용된 클래스
                                                    
                                                    toolbar={{
                                                        // inDropdown: 해당 항목과 관련된 항목을 드롭다운으로 나타낼것인지
                                                        list: { inDropdown: true },
                                                        textAlign: { inDropdown: true },
                                                        link: { inDropdown: true },
                                                        history: { inDropdown: false },
                                                    }}  // 툴바 설정

                                                    placeholder="내용을 작성해주세요."
                                                                                                        
                                                    localization={{
                                                        locale: 'ko',
                                                    }}  // 한국어 설정

                                                    onEditorStateChange={this.onEditorStateChange}  // 에디터의 값이 변경될 때마다 onEditorStateChange 호출
                                                />

                                                </MyBlockQW>

                                        </td>
                                    </tr>     
                                    </tbody>
                        </table>   {/*<!-- DO 테이블 END --> */}
                    </div>
    
                    
                        </div>
                </>
            );
        }
        
    }

}


export default FaqWrite;